export default __webpack_public_path__ + "static/media/angle-right-solid.41288587.svg";